import { render, staticRenderFns } from "./NavLanguages.vue?vue&type=template&id=82407d5e&scoped=true"
import script from "./NavLanguages.vue?vue&type=script&lang=js"
export * from "./NavLanguages.vue?vue&type=script&lang=js"
import style0 from "./NavLanguages.vue?vue&type=style&index=0&id=82407d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82407d5e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LanguagesIcon: require('C:/app/components/Svgs/LanguagesIcon.vue').default,ArrowDown: require('C:/app/components/Svgs/ArrowDown.vue').default})
